// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"125":"410c4875","353":"08d632f7","738":"ccf94f60"}[chunkId] + ".js";
};